import { AGE_GROUPS, EVENT_STATUS, INDUSTRY_TYPES, LANGUAGES, SKILL_LEVELS, SKILLS } from "utils/helpers/enums/shared.enum";
import { format } from "date-fns";
import { HostProfileDTO } from "../host/host-profile.dto";
import { PictureDTO } from "./picture.dto";
import { UserDTO } from "../users/user.dto";

export class EventDTO{
    id: number;
    title: string = ''
    description:  string = ''
    location:  string = ''
    ageGroup: AGE_GROUPS
    joineeSlots: number;
    skillLevel: SKILL_LEVELS = SKILL_LEVELS.EXCEPTIONAL_LEARNER;
    coreConcept: string[] = []
    parentSupervision: boolean = true;
    language: LANGUAGES
    physicalConsideration: string = ''
    specialInstructions: string = '';
    ambassadorSupportRequired: boolean = false;
    rsvpEmail: string = ''
    badgeUrlId: number;
    badgeUrl: any;
    entryFee: number = 0;
    rsvpId: any;
    ambassadorJoiningRequired: boolean = false;
    ambassadorJoiningSlots: number = 0;
    ambassadorOneId: number;
    ambassadorTwoId: number;
    ambassadorSupportSlots: number = 0;
    city: string = ''
    state: string = ''
    industryAndInterests: INDUSTRY_TYPES
    isSession: boolean = true;
    hostId: number;
    eventStatus: EVENT_STATUS
    deleted: boolean = false;
    workshopSessions: WorkshopSessionDTO[] = [new WorkshopSessionDTO()]
    host: HostProfileDTO = new HostProfileDTO();
    rsvp: any;
    eventSubscriptions: []
    eventPicsIds: number[] = []
    eventPics: PictureDTO[] = []
    eventPicsUrl: PictureDTO[] = []
    createdByHostId: number;
    availableSlots: number;

    constructor(data: Partial<EventDTO> = {}){
        for(let key in data){
            if(key === 'workshopSessions'){
                this[key] = data[key].map(i => new WorkshopSessionDTO(i))
            }else if(key === 'host'){
                this[key] = new HostProfileDTO(data[key] ?? {});
                console.log(this[key], 'this[key] laterone')
            }else if(key === 'eventPics' || key === 'eventPicsUrl'){
                this[key] = (data[key] ?? []).map(i => new PictureDTO(i));
            }else if(key === 'coreConcept'){
                this[key] = data.coreConcept.map(c => replaceUnderscores(c));
            }else if(Array.isArray(data[key])){
                this[key] = data[key] ?? [];
            }else if(key === 'ageGroup'){
                this[key] = replaceUnderscores(data[key]) as AGE_GROUPS;
            }else if(key === 'skillLevel'){
                this[key] = replaceUnderscores(data[key]) as SKILL_LEVELS;
            }else{
                this[key] = data[key];
            }
        }
    }
}

function replaceUnderscores(str: string): string{
    return str.replaceAll('_', ' ').toLowerCase()
}
export class WorkshopSessionDTO{
    id: number;
    startDateTime: string = ''
    endDateTime: string = '';
    endTime: string = ''
    eventId: number;
    deleted: boolean = false;
    year: number;
    startDate: string = '';
    startTime: string = '';
    startDateWithMonthAndYear: string = '';
    endDateWithMonthAndYear: string = ''
    month: string = '';
    rsvp: UserDTO = new UserDTO()

    constructor(data: Partial<WorkshopSessionDTO> = {}){
        for(let key in data){
            if(key === 'startDateTime'){
                this.startDate = new Date(data[key]).getDate().toString();
                this[key] = data[key];
                this.startDateWithMonthAndYear = format(new Date(data[key]), "dd MMMM, yyyy");
                this.startTime = format(new Date(data[key]), "hh:mm a");
                this.year = new Date(data[key]).getFullYear();
                this.month = format(new Date(data[key]), "MMM").toUpperCase()
            }else if(key === 'endDateTime') {
                this.endDateWithMonthAndYear = format(new Date(data[key]), "dd MMMM, yyyy");
                this.endTime = format(new Date(data[key]), "hh:mm a");
            }else{
                this[key] = data[key];
            }
        }
    }
}